import React, { Component } from "react";
import Select from "react-select";
import "./DropState.css";

class DropSources extends Component {
  render() {
    const { sourceOfPlan, selectedSource, handleSourceListChange } = this.props;
    const SourceListDisplay = sourceOfPlan.map((option) => {
      return { value: option.id, label: option.source };
    });
    const selectedValue = selectedSource
      ? SourceListDisplay.find((item) => item.label === selectedSource)
      : null;
    return (
      <div className="dd-wrapper styl-wrapper">
        <Select
          placeholder="All Sources"
          options={SourceListDisplay}
          value={selectedValue}
          onChange={handleSourceListChange}
        />
      </div>
    );
  }
}
export default DropSources;
